//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { Dashboard as DashboardIcon } from '@mui/icons-material';
import { TourInfo, TourStep } from '@/components/Help/tourTypes';
import { ERoutesRoot } from '@/routes/RoutesEnum';

const dashboardTourSteps: TourStep[] = [
  // Initial Step.
  {
    target: '[data-joyride-id="nav-dashboard"]',
    title: 'Dashboard Tour',
    content: 'If not already on the Dashboard page, click on the Dashboard ' +
             'button.',
    placement: 'bottom',
    blockTargetInteraction: false,
    actionHint: 'Click on the Dashboard button to continue',
    spotlightPadding: 6,
    beforeStep: (tourActions) => { tourActions.setIsNextDisabled(true); },
    advanceOnClick: true,
    nextPath: ERoutesRoot.Dashboard
  },

  // Welcome Widget
  {
    target: '[data-joyride-id="dashboard-welcome"]',
    title: 'Welcome Widget',
    content: 'The Welcome widget provides personalized information and quick ' +
             'access to common tasks.',
    placement: 'right'
  },

  // Recent Jobs Widget
  {
    target: '[data-joyride-id="dashboard-recent-jobs"]',
    title: 'Recent Jobs',
    content: 'This widget shows your most recent jobs. You can quickly ' +
             'access and review your latest activities here.',
    placement: 'right'
  },

  // Schema Widget
  {
    target: '[data-joyride-id="dashboard-schema"]',
    title: 'Schema Explorer',
    content: 'The Schema Widget displays your data model structure. This ' +
             'helps you understand the relationships between your data ' +
             'entities.',
    placement: 'left-start'
  },

  // Datasets Widget
  {
    target: '[data-joyride-id="dashboard-datasets"]',
    title: 'Datasets',
    content: 'The Datasets Widget shows all available datasets. You can ' +
             'explore and manage your data sources from here.',
    placement: 'right'
  },

  // Jobs Widget
  {
    target: '[data-joyride-id="dashboard-jobs"]',
    title: 'Jobs',
    content: 'The Jobs Widget displays your current and scheduled jobs. ' +
             'Monitor progress and manage your workloads here.',
    placement: 'left'
  },
];

export const dashboardTourInfo: TourInfo = {
  id: 'dashboard',
  title: 'Dashboard Overview',
  description: 'Learn about the dashboard widgets',
  icon: <DashboardIcon />,
  steps: dashboardTourSteps
};
